import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'

export const SC_DocumentsCategory = styled.div`
  background-color: ${E_Colors.White};
  padding: 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 80px;

  h5 {
    flex: 1;
    font-weight: 600;
  }
`